<template>
    <div class="home">
        <carousel/>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item> <a href="/">{{ $t('lang.index1') }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item>{{ $t('lang.Product') }}</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div" style="height: 830px">
            <div class="FL">
                <!--                <div class="menu-div">-->
                <!--                    <div class="text-align m10">-->
                <!--                        <img src="../../static/images/u34.png" class="img1">-->
                <!--                        <span style="font-size: 20px;" class="font-weight">{{ $t('lang.Product') }}</span>-->
                <!--                    </div>-->
                <!--                    <a-row v-for="(item,i) in navData" :key=i  @click="handleClick(item.id)" class="menu-li" :selected-keys="[this.goodsType]">-->
                <!--                        <a-col :span="5">-->
                <!--                            <img src="../../static/images/u45.png" class="img2">-->
                <!--                        </a-col>-->
                <!--                        <a-col :span="19" class="wrap">-->
                <!--                            <div id="one" @click="handleClick(item.id)">-->
                <!--                                {{ item.name }}-->
                <!--                            </div>-->
                <!--                        </a-col>-->
                <!--                    </a-row>-->
                <!--                </div>-->


                <div class="menu-div">
                    <div class="text-align m10">
                        <img src="../../static/images/u34.png" class="img1">
                        <span style="font-size: 20px;" class="font-weight">{{ $t('lang.Product') }}</span>
                    </div>
                    <a-menu mode="vertical" :selected-keys="[this.goodsType]">
                        <a-menu-item v-for="(item) in navData" :key=item.id @click="handleClick(item.id)">
                            <a-row>
                                <a-col :span="5">
                                    <img src="../../static/images/u45.png" class="img2">
                                </a-col>
                                <a-col :span="19" class="wrap">
                                    <div id="one">
                                        {{ item.name }}
                                    </div>
                                </a-col>
                            </a-row>
                        </a-menu-item>
                    </a-menu>
                </div>
            </div>
            <div class="FR" style="width: 1120px;">
                <p class="int-title margin-auto font-weight text-align">{{ TypeName }}</p>
                <div class="margin-auto font-weight text-align int-title2">{{ $t('lang.Foot') }}</div>
                <div class="ProductListDiv">
                    <a-row class="ProductDiv" v-for="(item,i) in goodsList" :key="i">
                        <a-col :span="6">
                            <img :src="item.image[0].url" class="ProductImg" :alt="item.name">
                        </a-col>
                        <a-col :span="18">
                            <p class="ProductName FontWeight">{{ item.name }}</p>
                            <div class="ProductMain">{{ item.introduction }}</div>
                            <div class="BigFont CheckInfo cursor-pointer" @click="getInfo(item.id)">+{{
                                    $t('lang.check')
                                }}
                            </div>
                        </a-col>
                    </a-row>
                    <div class="text-align">
                        <a-pagination v-if="total!==0" :current="current" :total=total @change="changePage"
                                      :defaultPageSize="limit"/>
                    </div>
                </div>
            </div>
            <div class="ClearFloat"></div>

        </div>
    </div>
</template>

<script>
import carousel from "@/components/carousel";
import {get} from "@/utils";
// import goodsList from "../../static/data/product.json";
// import navData from '../../static/data/LeftNav.json';

export default {
    name: "Goods",
    components: {
        carousel,
    },
    data() {
        return {
            goodsList: [],
            total: 0,
            limit: 4,
            current: 1,
            TypeName: '',
            navData: [],
            goodsType: 1,
            showGoods: [],
        }
    },
    mounted() {
        document.title = '产品中心'
        get('product/getProductCategoryList', {}).then(res => {
            this.navData = res.data.list;
            this.goodsType = Number(parseFloat(this.$route.params.id) || this.navData[0].id);
            this.getGoodList();
        }).catch(() => {
        })
    },
    methods: {
        getGoodList() {
            get('product/getProductListByCategory', {
                categoryId: this.goodsType,
                pageNum: this.current,
                pageSize: this.limit
            }).then(res => {
                this.goodsList = res.data.list;
                for (let items of this.navData) {
                    if (items.id === this.goodsType) {
                        this.TypeName = items.name;
                    }
                }
                this.total = res.data.total;
            }).catch(() => {
            })
        },
        getInfo(id) {
            // this.$router.push({path: '/goodInfo', query: {id}});
            this.$router.push({path: '/goodInfo/' + id + '.html'})
        },
        changePage(e) {
            const box = document.getElementsByTagName('html');
            box[0].scrollTop = 500;
            this.current = e;
            this.goodsList = [];
            this.getGoodList();
        },
        handleClick(e) {
            this.current = 1;
            this.goodsType = Number(e);
            this.getGoodList();
        },
    },
}
</script>

<style scoped>
.menu-li {
    overflow: hidden;
    text-overflow: ellipsis;
    border-top: 1px solid;
    height: 66px;
}

.wrap {
    display: table;
}

#one {
    cursor: pointer;
    width: 200px;
    height: 66px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
}

.ProductListDiv {
    width: 90%;
    border: 1px solid rgba(39, 148, 223, 1);
    margin: 0 auto;
    margin-top: 50px;
    padding: 25px;
    border-radius: 30px;
}

.ProductDiv {
    width: 100%;
    border-bottom: 1px solid #cccccc;
    margin-bottom: 40px;
}

.ProductImg {
    width: 200px;
    height: 200px;
}

.ProductName {
    width: 100%;
    font-size: 18px;
    line-height: 50px;
}

.ProductMain {
    width: 100%;
    height: 98px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}

.CheckInfo {
    color: #ffb700;
    line-height: 50px;
    font-size: 18px;
    width: 100px;
    height: 50px;
}

.BigFont:hover {
    font-size: 20px !important;
}

.menu-div {
    border: 1px solid #0099FF;
    width: 240px;
    /*height: 500px;*/
    padding: 0 16px;
}

.img1 {
    width: 50px;
    margin-right: 20px;
}

.img2 {
    margin-top: 12px;
    width: 40px;
    margin-right: 10px;
}

.m10 {
    margin: 20px 0;
}

.ant-menu-vertical .ant-menu-item:not(:last-child) {
    margin-bottom: 0 !important;
}

.ant-menu-submenu >>> .ant-menu-submenu-title {
    margin: 0 !important;
    height: 60px !important;
    line-height: 60px !important;
    font-size: 18px !important;
}

.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
    border: none;
}

.ant-menu-vertical .ant-menu-item {
    margin-top: 0 !important;
    height: 66px !important;
    padding: 0;
    border-top: 1px solid;
}
</style>
